import styled from '@emotion/styled';

export const SHeightContainer = styled.div`
  min-height: 650px;
  & .reporting-table {
    .ant-table-content {
      overflow-x: scroll;
    }
    .ant-table-thead > tr > th {
      padding-block: 0;
      height: 55px;
    }
    .ant-table-thead > tr:first-of-type > th[scope='colgroup'],
    .ant-table-thead > tr:nth-of-type(2) > th {
      padding-block: 0;
      height: 27px;
    }
  }
`;
